module.exports = __webpack_public_path__ + "static/img/new-11.55965221.jpg";